export function scrollIntoViewWithOffset(element, _a) {
    var top = _a.top, bottom = _a.bottom;
    var rect = element.getBoundingClientRect();
    var distanceToUpperWindowEdge = rect.top;
    var distanceToLowerWindowEdge = window.innerHeight - (distanceToUpperWindowEdge + rect.height);
    if (distanceToLowerWindowEdge < bottom) {
        window.scrollBy(0, bottom - distanceToLowerWindowEdge);
    }
    else if (distanceToUpperWindowEdge < top) {
        window.scrollBy(0, -(top - distanceToUpperWindowEdge));
    }
}
//# sourceMappingURL=utils.js.map